import { createSelector } from 'reselect';
import { getState } from './state';
export const getDrawerSlice = createSelector([
    getState
], (slice)=>{
    return slice.drawer;
});
export const getDrawerActiveFilter = createSelector(getDrawerSlice, (state)=>{
    var _state_activeFilter;
    return (_state_activeFilter = state === null || state === void 0 ? void 0 : state.activeFilter) !== null && _state_activeFilter !== void 0 ? _state_activeFilter : 'all';
});

//# sourceMappingURL=drawer.js.map